var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { MyAccountService } from "../../services/identity/myAccount.service";
import { useOrganizationAppsQuery } from "../hooks/app/useOrganizationApps";
import { useMarketplaceAppsQuery } from "../hooks/app/useMarketplaceApps";
import { resolvePermittedApp } from "./permittedApp";
import { CircularProgress } from "@mui/material";
var ProtectedRoute = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var appId = useParams().appId;
    var location = useLocation();
    var myAccountDataQ = useQuery(['myAccount'], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, MyAccountService.getMyAccount()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); });
    var organizationAppsQ = useOrganizationAppsQuery();
    var organizationApps = ((_a = organizationAppsQ.data) === null || _a === void 0 ? void 0 : _a.content) || [];
    // Only needed to translate a SKU matcher into an OrganizationApp.
    var marketplaceAppsQ = useMarketplaceAppsQuery(!!props.permittedApp);
    var marketplaceApps = ((_b = marketplaceAppsQ.data) === null || _b === void 0 ? void 0 : _b.content) || [];
    var permittedApp = resolvePermittedApp({
        organizationApps: organizationApps,
        marketplaceApps: marketplaceApps,
        pathname: location.pathname,
        appId: appId,
        matcher: props.permittedApp,
        legacyName: props.permittedAppName,
    });
    var createAppsProtectionCondition = function () {
        /*
            IMPORTANT:
            If permittedAppIds is null -> we need to give the access to every app
            Reason for this - we are introducing new fields to user, and on production all users have null value
            So we need to give them access to all apps until we migrate the data
        */
        var _a, _b, _c;
        // If permittedAppIds is null -> we need to give the access to every app
        if (!((_a = myAccountDataQ.data) === null || _a === void 0 ? void 0 : _a.permittedAppIds)) {
            return true;
        }
        // If organizationApps aren't loaded yet, we need to give the access to every app
        if (!organizationApps.length) {
            return true;
        }
        /*
            A SKU matcher can only be resolved against the marketplace catalogue. If that
            request failed or returned nothing, no app can ever be resolved - default to
            granting access rather than locking users out of apps they own, exactly as the
            two checks above do.
        */
        if (props.permittedApp && !marketplaceApps.length) {
            return true;
        }
        return (_c = (_b = myAccountDataQ.data) === null || _b === void 0 ? void 0 : _b.permittedAppIds) === null || _c === void 0 ? void 0 : _c.includes(permittedApp === null || permittedApp === void 0 ? void 0 : permittedApp.id);
    };
    var getUnauthorizedReason = function () {
        var _a;
        switch (props.protectionType) {
            case 'apps':
                if (!((_a = myAccountDataQ.data) === null || _a === void 0 ? void 0 : _a.permittedAppIds)) {
                    return 'apps access defaults to allowed because permittedAppIds is empty';
                }
                if (!organizationApps.length) {
                    return 'apps access defaults to allowed because organization apps are unavailable';
                }
                if (props.permittedApp && !marketplaceApps.length) {
                    return 'apps access defaults to allowed because the marketplace catalogue is unavailable';
                }
                if (!permittedApp) {
                    return 'apps access denied because no matching organization app was resolved from the route';
                }
                return "apps access denied because permittedAppIds does not include app ".concat(permittedApp.id);
            case 'billing':
                return 'billing access denied because billingAccess is false';
            case 'marketplace':
                return 'marketplace access denied because marketplaceAccess is false';
            case 'settings':
                return 'settings access denied because settingsAccess is false';
        }
    };
    // Creating generic condition for accessing different aspects
    var condition = undefined;
    switch (props.protectionType) {
        case 'apps':
            condition = createAppsProtectionCondition();
            break;
        case 'billing':
            // Grant access if billingAccess is null or undefined, otherwise use its value
            condition = (_d = (_c = myAccountDataQ.data) === null || _c === void 0 ? void 0 : _c.billingAccess) !== null && _d !== void 0 ? _d : true;
            break;
        case 'marketplace':
            // Grant access if marketplaceAccess is null or undefined, otherwise use its value
            condition = (_f = (_e = myAccountDataQ.data) === null || _e === void 0 ? void 0 : _e.marketplaceAccess) !== null && _f !== void 0 ? _f : true;
            break;
        case 'settings':
            // Grant access if settingsAccess is null or undefined, otherwise use its value
            condition = (_h = (_g = myAccountDataQ.data) === null || _g === void 0 ? void 0 : _g.settingsAccess) !== null && _h !== void 0 ? _h : true;
            break;
    }
    if (myAccountDataQ.isLoading || organizationAppsQ.isLoading || marketplaceAppsQ.isLoading) {
        return _jsx(CircularProgress, { size: 20 });
    }
    if (!condition) {
        console.log('[ProtectedRoute] Redirecting to /unauthorized', {
            pathname: location.pathname,
            protectionType: props.protectionType,
            appId: appId,
            permittedAppSku: (_j = props.permittedApp) === null || _j === void 0 ? void 0 : _j.sku,
            permittedAppSpecialization: (_k = props.permittedApp) === null || _k === void 0 ? void 0 : _k.specialization,
            permittedAppName: props.permittedAppName,
            permittedAppId: permittedApp === null || permittedApp === void 0 ? void 0 : permittedApp.id,
            permittedAppIds: (_l = myAccountDataQ.data) === null || _l === void 0 ? void 0 : _l.permittedAppIds,
            billingAccess: (_m = myAccountDataQ.data) === null || _m === void 0 ? void 0 : _m.billingAccess,
            marketplaceAccess: (_o = myAccountDataQ.data) === null || _o === void 0 ? void 0 : _o.marketplaceAccess,
            settingsAccess: (_p = myAccountDataQ.data) === null || _p === void 0 ? void 0 : _p.settingsAccess,
            reason: getUnauthorizedReason(),
        });
        return _jsx(Navigate, { to: "/unauthorized", replace: true });
    }
    return _jsx(_Fragment, { children: props.children });
};
export default ProtectedRoute;
